/**
 * Ошибка сети или сервера (§11.3, §4.7).
 *
 * Правило спеки: заголовок «Не удалось загрузить бренды», под ним текст ошибки
 * сервера как есть (error.message приходит уже по-русски) и одна кнопка
 * «Повторить». Пустое состояние всегда даёт выход одной кнопкой (§11.2).
 */
import { texts } from '../texts.js'
import './screens.css'

export interface ErrorScreenProps {
  /** Текст ошибки сервера. Показывается дословно. */
  message?: string | null
  title?: string
  onRetry?: () => void
}

export function ErrorScreen({ message, title = texts.error.brandsTitle, onRetry }: ErrorScreenProps) {
  return (
    <div className="state" role="alert">
      <div className="state__box">
        <h1 className="state__title">{title}</h1>
        <p className="state__text">{message ?? texts.error.unknown}</p>
        {onRetry && (
          <div className="state__actions">
            <button type="button" className="sbtn" onClick={onRetry}>
              {texts.action.retry}
            </button>
          </div>
        )}
      </div>
    </div>
  )
}
